import { render, staticRenderFns } from "./MarketAccounting.vue?vue&type=template&id=c85565d8"
import script from "./MarketAccounting.vue?vue&type=script&lang=js"
export * from "./MarketAccounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports